module.exports = __webpack_public_path__ + "static/media/kit_bg.3b4c126e.png";